.message {
  margin: 0;
  font: var(--t-body);
  color: var(--ink);
}

.evidence {
  margin: var(--space-3) 0 0;
  padding: 0 0 0 var(--space-5);
  font: var(--t-small);
  color: var(--graphite);
}
